export default Object.freeze({
  Default: 'default',
});
